import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-frame border-primary-50" }
const _hoisted_2 = { class: "panel-frame-header" }
const _hoisted_3 = { class: "h3 mb-s6" }
const _hoisted_4 = { class: "panel-frame-close-icon" }
const _hoisted_5 = { class: "mr-s1" }

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { STEP_STATUS, StepInfo } from '@/components/stepper/stepper.types';
import Step from '@/components/stepper/Step.vue';
import Icon from '@/components/icon/Icon.vue';
import { computed } from 'vue';
import { SingleSideActionName } from '@/views/pages/liquidity/single-side/models/single-side';
import ControlIcon from '@/components/icon/ControlIcon.vue';
import { useSingleSideDepositSteps } from '@/store/modules/single-side/useSingleSideDepositSteps';
import { useSingleSideWithdrawSteps } from '@/store/modules/single-side/useSingleSideWithdrawSteps';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSideSteps',
  props: {
    action: null
  },
  emits: ["onClose"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onClose'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  action: SingleSideActionName;
}





const { t, te } = useI18n();
const { state } = useStore();
const { singleSideDepositSteps, $reset: resetSingleSideDepositSteps } = useSingleSideDepositSteps();
const { singleSideWithdrawSteps, $reset: resetSingleSideWithdraw } = useSingleSideWithdrawSteps();

const header = computed(() =>
  t(`singleSide.steps.header.${props.action}`, {
    portfolioName: 'portfolioName',
  }),
);

const singleSideSteps = computed(() => {
  if (props.action === 'deposit') {
    return singleSideDepositSteps.steps;
  }

  return singleSideWithdrawSteps.steps;
});

const isError = computed(() =>
  singleSideSteps.value.some((step: StepInfo) => step.status === STEP_STATUS.ERROR),
);

const isSuccessful = computed(() =>
  singleSideSteps.value.every((step: StepInfo) => step.status === STEP_STATUS.SUCCESS),
);

const infoMessage = computed(() => {
  const currentActiveIndx = singleSideSteps.value.findIndex(
    step => step.status === STEP_STATUS.ACTIVE,
  );
  const msgType = singleSideSteps.value[currentActiveIndx]?.type ?? 'default';
  return te(`singleSide.steps.infoMessage.${msgType}`)
    ? t(`singleSide.steps.infoMessage.${msgType}`)
    : t('wrappedContract.steps.infoMessage.default');
});

function resetSteps() {
  const reset = props.action === 'deposit' ? resetSingleSideDepositSteps : resetSingleSideWithdraw;
  reset();
}

const onCloseSteps = () => {
  resetSteps();
  emits('onClose');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(header)), 1),
        _createElementVNode("div", _hoisted_4, [
          (_unref(isError) || _unref(isSuccessful))
            ? (_openBlock(), _createBlock(ControlIcon, {
                key: 0,
                name: "close",
                onClick: onCloseSteps
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex p-s3 mb-s3", _unref(isError) ? 'panel-message-error' : 'panel-message-info'])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Icon, {
            name: "error",
            size: "16"
          })
        ]),
        _createElementVNode("div", null, _toDisplayString(_unref(isError) ? _unref(t)('wrappedContract.steps.infoMessage.error') : _unref(infoMessage)), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["steps", _unref(state).layout.isMobile ? 'steps-column' : 'steps-row'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(singleSideSteps), (step, index) => {
          return (_openBlock(), _createBlock(Step, {
            key: index,
            number: index + 1,
            name: step.name!,
            status: step.status
          }, null, 8, ["number", "name", "status"]))
        }), 128))
      ], 2)
    ])
  ]))
}
}

})